var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",class:_vm.customClass,attrs:{"aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":_vm.total}},[_c('div',{staticClass:"progress-bar",style:(`width: ${_vm.value*100/_vm.total}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }